import { render, staticRenderFns } from "./Founder.vue?vue&type=template&id=164e8596&scoped=true"
import script from "./Founder.vue?vue&type=script&lang=js"
export * from "./Founder.vue?vue&type=script&lang=js"
import style0 from "./Founder.vue?vue&type=style&index=0&id=164e8596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e8596",
  null
  
)

export default component.exports